/**
 * router/routes/ayuda.routes.ts
 * Centro de ayuda — open to every tenant user; each article filters itself
 * by module and capability (modules/ayuda/help-registry.ts).
 */
import type { RouteRecordRaw } from 'vue-router';

export const ayudaRoutes: RouteRecordRaw[] = [
  {
    path: 'ayuda',
    name: 'ayuda',
    component: () => import('../../views/ayuda/HelpCenterView.vue'),
    meta: { hideSidebar: true },
  },
  {
    path: 'ayuda/:slug',
    name: 'ayuda-articulo',
    component: () => import('../../views/ayuda/HelpArticleView.vue'),
    meta: { hideSidebar: true },
  },
  {
    path: 'ayuda/:slug/:task',
    name: 'ayuda-tarea',
    component: () => import('../../views/ayuda/HelpTaskView.vue'),
    meta: { hideSidebar: true },
  },
];
